import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Avatar,
  Typography,
  CircularProgress,
  Button,
  Divider,
  Card,
} from "@material-ui/core";
import firebase from "../../../../../../common/firebase";
import Swal from "sweetalert2";
import { isStudent } from "../../../../../../common/envConfig";

const useStyles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minHeight: "fit-content",
    marginBottom: theme.spacing(1),
  },
  avatarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  avatar: {
    width: 50,
    height: 50,
  },
  name: {
    marginLeft: 15,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    maxWidth: "100px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  email: {
    marginLeft: 15,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    maxWidth: "100px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  heading: {
    fontFamily: "Manrope",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    marginBottom: 15,
  },
  text: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    marginBottom: 10,
  },
  button: {
    marginLeft: 7,
  },
  card: {
    backgroundImage: `url("/images/icons/Background pattern decorative.png")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    background: `#F9F5FF`,
    padding: theme.spacing(2),
    color: "black",
  },
  cardText: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0em",
    textAlign: "left",
    marginBottom: 10,
    color: "black",
  },
  primaryButton: {
    width: "60%",
    marginTop: "20px",
    backgroundColor: "#6D28D9",
    color: "#fff",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px",
    borderRadius: "36px",
    border: "none",
    cursor: "pointer",
    textAlign: "center",
  },
});

class Profile extends React.Component {
  constructor(props) {
    super(props);
    const firebaseUser = firebase.auth().currentUser;

    this.state = {
      name: "",
      avatar: "",
      role: "",
      email: "",
      subscriptionType: "",
      uid: firebaseUser ? firebaseUser.uid : "",
      studentCredits: 0,
      reportCredits: 0,
      loading: true,
    };
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const userSnap = await firebase
          .firestore()
          .collection("users")
          .doc(user.uid)
          .get();
        if (!userSnap.exists) {
          console.log("No matching documents for UID: " + user.uid);
          this.setState({
            error: "The signed in user does not exist",
          });
        }

        const userDoc = userSnap.data();
        if (userDoc) {
          this.setState({
            role: userDoc?.role,
            email: userDoc?.email,
            name: userDoc?.firstName + " " + userDoc?.lastName,
            avatar: userDoc?.picture,
            studentCredits: userDoc?.creditCount || 0,
            reportCredits: userDoc?.reportCredits || 0,
            subscriptionType: userDoc?.subscriptionType,
            loading: false,
          });
        }
      }
    });
  }

  handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your account",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: {
        container: "my-swal",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.props.history.push("/sign-in");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  getInitials = (name) => {
    const words = name.split(" ");
    let initials = "";

    for (let i = 0; i < words.length; i++) {
      initials += words[i].charAt(0);
    }
    initials = initials.toUpperCase();

    return initials;
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.subscriptionType !== "" &&
          !isStudent(this.state.subscriptionType) && (
            <Card className={classes.card}>
              <Typography variant="h4" className={classes.cardText}>
                <Typography component="span" className={classes.cardText}>
                  Credits Wallet
                </Typography>
                <br />
                <br />
                <Typography component="span" className={classes.cardText}>
                  <span style={{ color: "gray" }}>Reports Credits:</span>{" "}
                  <u>{this.state.reportCredits}</u>
                </Typography>
                <br />
                <Typography component="span" className={classes.cardText}>
                  <span style={{ color: "gray" }}>Student Credits:</span>{" "}
                  <u>{this.state.studentCredits}</u>
                </Typography>
                <Typography
                  component="div"
                  className={classes.primaryButton}
                  onClick={() => this.props.history.push("/credits")}
                  style={{ cursor: "pointer" }}
                >
                  Add credits
                </Typography>
              </Typography>
            </Card>
          )}
        <div style={{ height: "24px" }}></div>
        <Typography
          style={{ fontSize: "16px" }}
          variant="h4"
          className={classes.heading}
        >
          Need Help?
        </Typography>
        {this.state.subscriptionType !== "" &&
          (this.state.subscriptionType.includes("enterprise") ||
            this.state.role === "admin") && (
            <Typography variant="body2" className={classes.text}>
              Contact us directly{"   "}
              <Button
                className={classes.button}
                onClick={() =>
                  (window.location.href = "mailto:enterprise@sportsbox.ai")
                }
              >
                <img src="/images/icons/navigation.png" />
              </Button>
            </Typography>
          )}
        <Typography variant="body2" className={classes.text}>
          Visit our help center
          <Button
            className={classes.button}
            onClick={() => window.open("https://help.sportsbox.ai/")}
          >
            <img src="/images/icons/navigation.png" />
          </Button>
        </Typography>
        <Divider className={classes.divider} />
        <div className={classes.avatarContainer}>
          <Avatar
            component={RouterLink}
            to="/account"
            className={classes.avatar}
            src={this.state.avatar}
            style={{ display: this.state.loading ? "none" : "flex" }}
          >
            {!this.state.avatar ? this.getInitials(this.state.name) : ""}
          </Avatar>
          <div className={classes.root}>
            <Typography variant="h5" className={classes.name}>
              {this.state.name}
            </Typography>
            <Typography variant="body2" className={classes.email}>
              {this.state.email}
            </Typography>
          </div>
          <Button onClick={() => this.handleLogout()}>
            <img src="/images/icons/logout_button.png" />
          </Button>
          <CircularProgress
            style={{ display: this.state.loading ? "block" : "none" }}
          />
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(Profile);
